<div class="row d-block animated fadeIn m-1">
  <div formGroupName="accountingInfo" class="p-fluid">
    <div class="row mb-3">
      <ibp-form-header class="col-12 mb-2"
                       [titleSize]="4"
                       [title]="'CLIENT_CREATION.ACCOUNTING_INFO.TAX_AND_ACCOUNTING_TITLE' | translate"
                       [description]="'CLIENT_CREATION.ACCOUNTING_INFO.TAX_AND_ACCOUNTING_DESCRIPTION' | translate">
      </ibp-form-header>
    </div>
    <div class="row mb-3">
      <ibp-form-header class="col-12 mb-2"
                       [titleSize]="6"
                       [title]="'CLIENT_CREATION.ACCOUNTING_INFO.TAX_RELEVANT_INFO_TITLE' | translate">
      </ibp-form-header>
      <ibp-text-input [label]="'CLIENT_CREATION.ACCOUNTING_INFO.VAT_BUSINESS_NUMBER' | translate"
                      formControlName="vatBusinessNumber"
                      class="col-12 mb-3"
                      ibpVatAutoFormat
                      [vatCountry]="selectedCountry$ | async">
      </ibp-text-input>
      <ibp-checkbox class="col-12 mb-3 flex align-items-center gap-3"
                    [label]="'CLIENT_CREATION.ACCOUNTING_INFO.VAT_LIABLE'"
                    formControlName="vatLiable">
      </ibp-checkbox>
      @if (form.get('accountingInfo.vatLiable').value === true) {
        <ibp-radio-button class="col-12 mb-3"
                          formControlName="vatMethod"
                          [label]="'COMPANY_PROPERTIES.FORM.VAT_METHOD'"
                          [columns]="2"
                          [radioOptions]="vatMethodRadioOptions">
        </ibp-radio-button>
      }
    </div>
    <div class="row mb-3">
      <ibp-form-header class="col-12 mb-2"
                       [titleSize]="6"
                       [title]="'CLIENT_CREATION.ACCOUNTING_INFO.ACCOUNTING_INFO_TITLE' | translate"
                       [description]="'CLIENT_CREATION.ACCOUNTING_INFO.ACCOUNTING_INFO_DESCRIPTION' | translate">
      </ibp-form-header>
      <ibp-select class="col-12 mb-3"
                  formControlName="chartOfAccountType"
                  [label]="'CLIENT_CREATION.ACCOUNTING_INFO.CHART_OF_ACCOUNT_TYPE'"
                  [options]="chartOfAccountTypeOptions">
      </ibp-select>
      <ibp-select class="col-12 mb-3"
                  formControlName="currency"
                  [label]="'CLIENT_CREATION.ACCOUNTING_INFO.CURRENCY'"
                  [options]="currencyOptions$ | async">
      </ibp-select>
      <div class="w-100"></div>

      <ibp-form-header class="col-12 mb-2"
                       [titleSize]="6"
                       [title]="''"
                       [description]="'CLIENT_CREATION.ACCOUNTING_INFO.DATE_RANGE_DESCRIPTION' | translate">
      </ibp-form-header>
      <ibp-calendar class="col-6 mb-3"
                    formControlName="entryDate"
                    [label]="'CLIENT_CREATION.ACCOUNTING_INFO.ENTRY_DATE'"
                    [showIcon]="true">
      </ibp-calendar>
      <ibp-calendar class="col-6 mb-3"
                    formControlName="exitDate"
                    [label]="'CLIENT_CREATION.ACCOUNTING_INFO.EXIT_DATE'"
                    [showIcon]="true">
      </ibp-calendar>
      <ibp-form-header class="col-12 mb-2"
                       [titleSize]="6"
                       [title]="''"
                       [description]="'CLIENT_CREATION.ACCOUNTING_INFO.LANGUAGE_DESCRIPTION' | translate">
      </ibp-form-header>
      <ibp-select class="col-12 mb-3"
                  [label]="'FORM.LANGUAGE'"
                  [options]="languageOptions$ | async"
                  formControlName="language">
      </ibp-select>
    </div>
    <div class="row mb-3">
      <ibp-form-header class="col-12 mb-2"
                       [titleSize]="6"
                       [title]="'CLIENT_CREATION.ACCOUNTING_INFO.CLIENT_SUPERVISORS_TITLE' | translate"
                       [description]="'CLIENT_CREATION.ACCOUNTING_INFO.CLIENT_SUPERVISORS_DESCRIPTION' | translate">
      </ibp-form-header>
      <ibp-select [label]="'CLIENT_CREATION.ACCOUNTING_INFO.ONLINE_CONSULTANT' | translate"
                  formControlName="onlineFiduciary"
                  class="col-4 mb-3"
                  [options]="users$ | async">
      </ibp-select>
      <ibp-select [label]="'CLIENT_CREATION.ACCOUNTING_INFO.ONLINE_CONTACT_PERSON' | translate"
                  formControlName="onlineAccountant"
                  class="col-4 mb-3"
                  [options]="users$ | async">
      </ibp-select>
      <ibp-select [label]="'CLIENT_CREATION.ACCOUNTING_INFO.ONLINE_SUBSTITUTE' | translate"
                  formControlName="onlineSubstitute"
                  class="col-4 mb-3"
                  [options]="users$ | async">
      </ibp-select>
    </div>
    <div class="row mb-3">
      <ibp-form-header class="col-12 mb-2"
                       [titleSize]="6"
                       [title]="'CLIENT_CREATION.ACCOUNTING_INFO.BUSINESS_PURPOSE_TITLE' | translate"
                       [description]="'CLIENT_CREATION.ACCOUNTING_INFO.BUSINESS_PURPOSE_DESCRIPTION' | translate">
      </ibp-form-header>
      <ibp-input-textarea class="col-12 mb-3"
                          [autoResize]="false"
                          [rows]="6"
                          formControlName="businessPurpose"
                          ibpTooltip
                          [content]="'CLIENT_CREATION.ACCOUNTING_INFO.BUSINESS_PURPOSE_TOOLTIP' | translate"
                          [tooltipPosition]="'bottom'"></ibp-input-textarea>
    </div>
  </div>
</div>

<div class="d-flex pt-4 justify-content-end" style="gap: 20px;">
  <ibp-button [label]="'BTN.BACK'"
              [icon]="['fas', 'chevron-left']"
              (onClick)="prevCallback.emit()">
  </ibp-button>
  <ibp-button [label]="'BTN.CONTINUE'"
              [iconPos]="'right'"
              [disabled]="!isFormDisabledOrValid()"
              [icon]="['fas', 'chevron-right']"
              (onClick)="onNextClick()">
  </ibp-button>
</div>
